import React, { useState, useEffect } from "react";
import Api from "../../../config/Api";
import { toast } from "react-toastify";

const FilterComponent = ({ filters, onChange }) => {
  const [districts, setDistricts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getDistricts = async () => {
    setIsLoading(true);
    try {
      const res = await Api("get-district");
      if (res?.data?.status === 1) {
        setDistricts(res?.data?.district || []);
      } else {
        toast.error(res?.data?.message || "Failed to load districts", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } catch (err) {
      console.error("❌ Error fetching districts:", err);
      toast.error("Something went wrong while fetching districts", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getDistricts();
  }, []);

  const handleChange = (key, value) => {
    onChange({
      ...filters,
      [key]: value,
    });
  };

  return (
    <div
      style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}
    >
      {/* District Dropdown */}
      <select
        className="filter_comp"
        value={filters.district}
        onChange={(e) => handleChange("district", e.target.value)}
        disabled={isLoading}
      >
        <option value="">All Districts</option>
        {districts
          .filter((district) => district.status === "Active")
          .map((district) => (
            <option key={district.id} value={district.id}>
              {district.district_name}
            </option>
          ))}
      </select>

      {/* Application ID Search */}
      <input
        className="filter_comp"
        type="text"
        placeholder="Search Application ID"
        value={filters.applicationId}
        onChange={(e) => handleChange("applicationId", e.target.value)}
      />

      {/* Sort by Amount */}
      <select
        className="filter_comp"
        value={filters.sortOrder}
        onChange={(e) => handleChange("sortOrder", e.target.value)}
      >
        <option value="">Sort by Amount</option>
        <option value="asc">Low → High</option>
        <option value="desc">High → Low</option>
      </select>
    </div>
  );
};

export default FilterComponent;